import { HomePage, ContextSelectorPage, CreateMerchantPage, CreateOrderPage, CreateProductPage, CreateSaleCircuitPage, CreateSalePointPage, EditSalePointPage, ListCatalogPage, ListProductPage, ListSalePointPage, SignUpPage, type IContextSelectorArgs, type ICreateProductArgs, type ICreateSalePointArgs, type IHomePageArgs, EditProductPage, CustomerWalletPage, InitCardPage, OrderDetailsPage, RechargeCardPage, RefundCardPage, RegisterDevicePage, type IRechargeCardArgs, type IRefundCardPageArgs, type IRegisterDeviceArgs } from "../pages";
import { AcceptAccessRequestPage, type IAcceptAccessRequestArgs } from "../pages/account/AcceptAccessRequestPage";
import { ListDevicePage } from "../pages/account/ListDevicePage";
import { ListSessionPage } from "../pages/account/ListSessionPage";
import { LoginPage, type ILoginArgs } from "../pages/account/LoginPage";
import { ErrorPage, type IErrorPageArgs } from "../pages/ErrorPage";
import { ListOrderPage } from "../pages/order/ListOrderPage";
import { CardDetailsPage, type ICardDetailsArgs } from "../pages/paymentCard/CardDetailsPage";
import { ListCardPage } from "../pages/paymentCard/ListCardPage";
import { CreateCatalogPage } from "../pages/product/EditCatalog";
import { EditFullCatalogPage, type IEditFullCatalogArgs } from "../pages/product/EditFullCatalogPage";
import { OrderReportPage } from "../pages/report/OrderReportPage";
import { WalletReportPage } from "../pages/report/WalletReportPage";
import { SaleCircuitOptionsPage, type ISaleCircuitOptionsArgs } from "../pages/saleCircuit/SaleCircuitOptionsPage";
import type { IOrderDetailsArgs } from "../pages/order/OrderDetailsPage";
import { DelegateDevicePage } from "../pages/account/DelegateDevicePage";
import { ListMerchantServicesPage } from "../pages/merchant/ListMerchantServicesPage";
import { EditMerchantServicePage } from "../pages/merchant/EditMerchantServicePage";



export const PAGES = [
    LoginPage,
    HomePage,
    SignUpPage,
    CreateSaleCircuitPage,
    CreateSalePointPage,
    EditSalePointPage,
    CreateMerchantPage,
    ErrorPage,
    ListSalePointPage,
    ListProductPage,
    CreateOrderPage,
    ContextSelectorPage,
    CreateProductPage,
    ListCatalogPage,
    CreateCatalogPage,
    InitCardPage,
    RechargeCardPage,
    RefundCardPage,
    CardDetailsPage,
    ListCardPage,
    ListOrderPage,
    OrderDetailsPage,
    ListSessionPage,
    ListDevicePage,
    RegisterDevicePage,
    DelegateDevicePage,
    AcceptAccessRequestPage,
    CustomerWalletPage,
    EditFullCatalogPage,
    EditProductPage,
    SaleCircuitOptionsPage,
    WalletReportPage,
    OrderReportPage,
    ListMerchantServicesPage,
    EditMerchantServicePage
];

export type PagesMap = {
    "login": ILoginArgs,
    "sign-up": undefined,
    "home": IHomePageArgs,
    "merchant-create": undefined,
    "sale-point-create": ICreateSalePointArgs,
    "sale-circuit-create": undefined,
    "sale-point-list": undefined,
    "create-product": ICreateProductArgs,
    "error": IErrorPageArgs,
    "context-selector": IContextSelectorArgs,
    "recharge-card": IRechargeCardArgs,
    "refund-card": IRefundCardPageArgs,
    "card-details": ICardDetailsArgs,
    "order-details": IOrderDetailsArgs,
    "register-device": IRegisterDeviceArgs, 
    "delegate-device": undefined,
    "access-request": IAcceptAccessRequestArgs,
    "edit-full-catalog": IEditFullCatalogArgs,
    "sale-circuit-options": ISaleCircuitOptionsArgs
}
